import Typography, { TypographySizedProps, TypographySizesStyles, TypographyStyles } from '@viterbit/web-app/shared/typography/Typography'

export const TitleStyles = {
    ...TypographyStyles,
    root: `${TypographyStyles.root} ${TypographySizesStyles.title}`,
} as const

const Title = (props: TypographySizedProps) => {
    return (
        <Typography {...props} size='title' />
    )
}

export default Title
